// pages/Dashboard/Dashboard.js
function Dashboard() {
  return <h2>Dashboard Overview</h2>;
}

export default Dashboard;